<div class="screensaver" [class.active]="isScreensaverActive">
    <div class="screensaver-content">
        <div class="logo">
            <img src="../../assets/banners/splash_tve.png" alt="">
        </div>
    </div>
</div>
